import { atom } from "recoil";

export const invalidCellsState = atom<Array<string>>({
  key: "invalidCellsState",
  default: Array<string>(),
});
